export const guided_setup = [
  {
    name: 'settings',
    title: "Review your company's profile & settings",
    link: '/settings'
  },
  {
    name: 'roles',
    title:
      "Manage your company's organizational structure (Roles & Permissions)",
    link: '/users/roles'
  },
  {
    name: 'services',
    title: 'Add the services you render',
    link: '/services'
  },
  {
    name: 'clients',
    title: 'Manage your Clients Data',
    link: '/locations'
  },
  {
    name: 'staffs',
    title: 'Invite your staffs to join the company',
    link: '/users'
  },
  {
    name: 'schedules',
    title: 'Create your first schedule',
    link: '/schedules'
  }
]
